export enum FEATURE_FLAGS {
  ENABLE_LANGUES_DEMO_SIMPLE_CARDS = "mw-langues-demo-simple-cards",
  ENABLE_VOICES_SLIDER_NO_AUTOSCROLL = "mw-voices-slider-no-autoscroll",
  ENABLE_VOICE_CHANGER_SOFT_NUDGE_V2 = "mw-voice-changer-soft-nudge-v2",
  ENABLE_VOICE_CLONING_SOFT_NUDGE_V2 = "mw-voice-cloning-soft-nudge-v2",
  ENABLE_NAV_CTA_TEST = "mw-default-add-contact-sales-to-contextual-nav",
  ENABLE_MUSIC_CATEGORY_V2 = "mw-music-category-redesign-no-ugc-4",
  ENABLE_TTS_SOCIAL_PROOF_LAUREL_ITERATION = "mw-tts-social-proof-laurel-iteration",
  ENABLE_ELVENLABS_PAGE = "mw-elvenlabs-page",
  ENABLE_AGENTS_CTA_FORTUNE_500_SOCIAL_PROOF = "mw-agents-cta-fortune-500-social-proof",
  ENABLE_FLOATING_AGENT_REDESIGN = "mw-floating-agent-redesign",
  ENABLE_PRICING_API_V4 = "mw-pricing-api-v4",
  ENABLE_SESSION_RECORDING = "mw-session-recording",
  ENABLE_MUSIC_PRICING_V2 = "mw-music-pricing-v2",
  ENABLE_DUBBING_PRICING_V2 = "mw-dubbing-pricing-v2",
  ENABLE_CONTACT_SALES_SOCIAL_PROOF = "mw-contact-sales-social-proof",
}
